import React from 'react'

const ProgressBarRoutes = ({
  totalPoints,
  completedPoints,
  routeInfo,
  handleEditRoutesPoints,
  status,
}) => {
  const getProcessAndStyle = () => {
    if (totalPoints === 0) {
      return {
        progress: 0,
        color: '#ADD8E6',
        labelMain: '---',
      }
    }

    if (totalPoints) {
      return {
        progress: Math.round((completedPoints / totalPoints) * 100),
        color: '#ADD8E6',
        labelMain: '---',
      }
    }

    if (status) {
      return {
        progress: status.progress,
        color: status.color,
        labelMain: status.name,
      }
    }
  }

  const { progress, color, labelMain } = getProcessAndStyle()

  return (
    <div className={`progress-bar-container`}>
      <div
        className={`progress-bar`}
        style={{
          width: `${progress}%`,
          backgroundColor: color,
        }}
      ></div>{' '}
      {totalPoints >= 0 && (
        <div
          className={`progress-bar-text-container ${
            routeInfo ? 'progress-button' : ''
          }`}
          data-toggle="tooltip"
          data-placement="top"
          title="Click para ver detalles de las rutas"
          onClick={
            routeInfo
              ? () =>
                  handleEditRoutesPoints(
                    routeInfo.id,
                    routeInfo.RoutesToStatus.name,
                    routeInfo
                  )
              : null
          }
        >
          <span
            className="progress-bar-text"
            aria-details={`Click para ver detalles de la ruta`}
          >
            {completedPoints} / {totalPoints}
          </span>
        </div>
      )}
      {status && (
        <div className={`progress-bar-text-container`}>
          <span
            className="progress-bar-text"
            aria-details={`Click para ver detalles de la ruta`}
          >
            {labelMain}
          </span>
        </div>
      )}
    </div>
  )
}

export default ProgressBarRoutes
